/**
 * Taken and modified from https://github.com/emberjs/data/blob/e78d6fe971c42ef238d6bb54380c4ef5ce0ff1c1/packages/adapter/addon/-private/utils/serialize-query-params.ts#L11
 * The `serializeQueryParams` function is unmodified outside of conversion to JS,
 * but the `add` function was changed to allow for whitelisted query-param characters.
 */

import { queryPartCharacterWhitelist } from 'rise-ui/utils/url.js';
import { escapes } from 'rise-ui/utils/escape.js';

// Escape whitelist with non-encodeURIComponent-encodable tokens, encode with
// encodeURIComponent, then decode replacement tokens to whitelist characters.
const escape = escapes(
  queryPartCharacterWhitelist,
  '_',
  [].map.call(queryPartCharacterWhitelist,
    (c, i) => String.fromCharCode(97 + i)
  )
);
function encode(text) {
  return escape.unescape(encodeURIComponent(escape.escape(text)));
}

const RBRACKET = /\[]$/;

function isPlainObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}

/*
 * Helper function that turns the data/body of a request into a query param string.
 * This is directly copied from jQuery.param.
 */
export function serializeQueryParams(queryParamsObject) {
  let s = [];

  function buildParams(prefix, obj) {
    let i, len, key;

    if (prefix) {
      if (Array.isArray(obj)) {
        for (i = 0, len = obj.length; i < len; i++) {
          if (RBRACKET.test(prefix)) {
            add(s, prefix, obj[i]);
          } else {
            buildParams(prefix + '[' + (typeof obj[i] === 'object' ? i : '') + ']', obj[i]);
          }
        }
      } else if (isPlainObject(obj)) {
        for (key in obj) {
          buildParams(prefix + '[' + key + ']', obj[key]);
        }
      } else {
        add(s, prefix, obj);
      }
    } else if (Array.isArray(obj)) {
      for (i = 0, len = obj.length; i < len; i++) {
        add(s, obj[i].name, obj[i].value);
      }
    } else {
      for (key in obj) {
        buildParams(key, obj[key]);
      }
    }
    return s;
  }

  return buildParams('', queryParamsObject)
    .join('&')
    .replace(/%20/g, '+');
}

/*
 * Part of the `serializeQueryParams` helper function.
 */
function add(s, k, v) {
  // Strip out keys with undefined value and replace null values with
  // empty strings (mimics jQuery.ajax)
  if (v === undefined) {
    return;
  } else if (v === null) {
    v = '';
  }

  v = typeof v === 'function' ? v() : v;
  /** The following is the only line changed */
  s[s.length] = `${encode(k)}=${encode(v)}`;
}
